import { Component, OnInit, OnDestroy, AfterViewInit, effect } from '@angular/core';
import { ReactiveFormsModule, Validators, FormGroup, FormBuilder  } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';
import { CustomerFormat } from '../../../shared/models/customerFormat.model';
import { environment } from '../../../../environments/environment';
import { GoogleService } from '../../../shared/google.service';
import { uspsData } from '../../../shared/models/uspsData';
import { standardizedAddress } from '../../../shared/models/standardizedAddress';
import * as bootstrap from 'bootstrap';
import { GoogleMapsModule } from '@angular/google-maps';
import { PlanService } from '../../../shared/plan-data.service';
import { PromoService } from '../../../shared/promo.service';

@Component({
  selector: 'app-form-contact-info',
  template: `
  <section>
    <div>
      <div class="card-body" >
          <!-- <h3>{{this.session.plan.name}} plan</h3> -->
        <h3>Let's keep your identity <strong>Safe!</strong></h3>
        <p aria-label="Title for contact information step">Provide your contact information below.</p>
          <form [formGroup]="contactForm" >
            <div class="row ">
                <div class="col-lg-6 col-md-12  mb-3">
                  <label for="firstName" class="form-label input-labels">First name</label>
                  <input formControlName="firstName" type="text" class="form-control" name="firstName" placeholder="Enter name" autocomplete="given-name" >
                  @if(contactForm.controls['firstName'].invalid && contactForm.controls['firstName'].touched){
                    <div class="text-danger"> Please enter a valid first name. </div>
                  }
                </div>
                <div class="col-lg-6 col-md-12  mb-3">
                  <label for="lastName" class="form-label input-labels">Last name</label>
                  <input formControlName="lastName" type="text" class="form-control" name="lastName" placeholder="Enter name" autocomplete="family-name" >
                  @if(contactForm.controls['lastName'].invalid && contactForm.controls['lastName'].touched){
                    <div class="text-danger"> Please enter a valid last name. </div>
                  }
                </div>
            </div>
            <div class="row mb-3">
              <div class="col-12">
                <label for="address" class="form-label input-labels">Address</label>
                @if (isAddressVerified && isAddressComplete && verifyAddress) {
                  <span class="ms-1">
                    <img src="assets/Icons/check-circle.svg" alt="checkmark" title="Address Verified">
                  </span>
                }
                @if (!isAddressVerified && isAddressComplete && verifyAddress && !addressValidationPending) {
                  <span class="ms-1">
                    <img src="assets/Icons/exclamation-circle-red.svg" alt="checkmark" title="Address Not Verified">
                  </span>
                }
                <input id="address1" formControlName="address" type="text" class="form-control address-field" name="address" placeholder="Enter an address" autocomplete="street-address" >
                @if (contactForm.controls['address'].invalid && contactForm.controls['address'].touched) {
                  <div class="text-danger"> Please enter a valid address. </div>
                }
              </div>
            </div>

            <div class="row ">
              <div class="col-lg-9 col-md-12  mb-3">
                <label for="city" class="form-label input-labels">City</label>
                <input formControlName="city" name="city" type="text" class="form-control address-field" placeholder="Enter City" autocomplete="address-level2">
                @if (contactForm.controls['city'].invalid && contactForm.controls['city'].touched) {
                  <div class="text-danger"> Please enter a valid city. </div>
                }
              </div>

              <div class="col-lg-3 col-sm-6 col-xs-12 mb-3">
                <label for="state" class="form-label input-labels">State</label>
                <select formControlName="state" name="state" class="form-control address-field">
                  @for(stateID of this.stateIDs; track stateID){
                    <option [value]="stateID">{{stateID}}</option>
                  }
                </select>
                @if (contactForm.controls['state'].invalid && contactForm.controls['state'].touched) {
                  <div class="text-danger"> Please select a valid state. </div>
                }
              </div>
            </div>

            <div class="row ">
              <div class="col-lg-6 col-md-12  mb-3">
                <label id="zipcode" for="zipCode" class="form-label input-labels">ZIP code</label>
                <input formControlName="zipCode" type="tel" class="form-control address-field" name="zipCode" placeholder="Enter ZIP Code" inputmode="numeric" autocomplete="postal-code" required minlength="5" maxlength="5" >
                @if(contactForm.controls['zipCode'].invalid && contactForm.controls['zipCode'].touched){
                  <div class="text-danger"> Please enter a valid zip code. </div>
                }
              </div>
            </div>

            @if (verifyAddress && isAddressComplete && !isAddressVerified && !addressValidationPending) {
              <div class="row">
                <div class="col-12 mb-3">
                  <div class="text-danger">We couldn't verify this address. Please double-check the street, city, state, and ZIP code.</div>
                </div>
              </div>
            }

            <div class="row ">

              <div class="col-lg-6 col-md-12  mb-3">
                <label for="phone" class="form-label input-labels">Phone number</label>
                <input formControlName="phone" type="tel" class="form-control" name="phone" placeholder="Enter phone number" inputmode="decimal" autocomplete="tel-national" required minlength="10" maxlength="12">
                @if(contactForm.controls['phone'].invalid && contactForm.controls['phone'].touched){
                  <div class="text-danger"> Please enter a valid phone number. </div>
                }
              </div>

              <div class="col-lg-6 col-md-12  mb-3">
                <label for="email" class="form-label input-labels">Email address</label>
                <input formControlName="email" type="email" class="form-control" name="email" placeholder="Enter email address" inputmode="email" autocomplete="email" >
                @if (contactForm.controls['email'].invalid && contactForm.controls['email'].touched) {
                  <div class="text-danger"> Please enter a valid email. </div>
                }
            </div>

          </div>
        </form>

        <hr>
        <p class="legal-notice">{{this.contactPermissionMessage}}</p>
      </div>
    </div>
    
    <div id="modalAddressMismatch" class="modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Verify Address</h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <span>Entered Address</span>
                  </div>
                  <div class="card-body">
                    <div>{{enteredAddress.firstAddressLine}}</div>
                    <div>
                      <span>{{enteredAddress.city}}</span>,
                      <span>{{enteredAddress.state}}</span>
                    </div>  
                    <div>{{enteredAddress.zipCode}}</div>
                    <button class="btn btn-sm btn-outline-secondary w-100 mt-2" (click)="dismissAddressUpdate()">Keep Editing</button>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <span>Verified Address</span>
                  </div>
                  <div class="card-body">
                    <div>{{uspsData?.standardizedAddress?.firstAddressLine}}</div>
                    <div>
                      <span>{{uspsData?.standardizedAddress?.city}}</span>,
                      <span>{{uspsData?.standardizedAddress?.state}}</span>
                    </div>
                    <div>{{uspsData?.standardizedAddress?.zipCode}}</div>
                    <button class="btn btn-sm btn-success w-100 mt-2" (click)="updateAddressFromUsps()">Use Verified</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
  `,
  styleUrls: ['./form-contact-info.component.scss'],
  standalone: true,
  imports: [ 
    ReactiveFormsModule, 
    GoogleMapsModule
  ]
})
export class FormContactInfoComponent implements OnInit, OnDestroy, AfterViewInit {
  
  contactForm: FormGroup = new FormGroup({});

  get customer(): CustomerFormat {
    return this.directSessionLogic.customerSignal();
  }

  private intervalId: any;

  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phone: string = '';
  address: string = '';
  city: string = '';
  state: string = '';
  zipCode: string = '';
  country: string = '';

  verifyAddress:boolean = true;
  isAddressVerified:boolean = false;
  isAddressComplete:boolean = false;
  addressValidationPending:boolean = false;
  private suppressAddressInvalidation:boolean = false;
  private addressChanged$ = new Subject<void>();
  uspsData:uspsData | any = {};
  enteredAddress = {} as standardizedAddress;
  verifiedAddress = {} as standardizedAddress;
  modalAddressMismatch:any = {};

  autocompleteAddress: boolean = true;
  autocomplete: google.maps.places.Autocomplete = {} as google.maps.places.Autocomplete;
  updateFormLockout: boolean = false;

  companyName: string = "";
  contactPermissionMessage: string = "we may contact you if you click next";

  nameRegex: RegExp = /^[a-zA-Z\-]+$/;
  phoneRegex: RegExp = /^([0-9]{3})[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  zipCodeRegex: RegExp = /[0-9]{5}/;
  emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;


  //list of all valid two character state IDs
  stateIDs: string[] = [
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", 
    "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD", 
    "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", 
    "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", 
    "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
  ];

  validCountries: string[] = [
    "United States"
  ];

  constructor(
    public directSessionLogic: DirectSessionLogicService,
    private builder: FormBuilder,
    public googleService: GoogleService,
    public promoService: PromoService,
    public planService: PlanService
        
  ) {
    this.escapeCheck();

    effect(() => {
      let selectedPlan = this.directSessionLogic.planSelectedSignal();
      this.escapeCheck();
      if(this.planService.planSelectionFromUrl() != null && this.directSessionLogic.planSelectedSignal().name == undefined){
        this.planService.selectPlan();
        console.log("---Plan set in first page",this.planService.planSelectionFromUrl())
      }
    });

    effect(() => {
      if(this.customer.firstName != undefined){
        this.setContactFromSession();          
      }
    });


    effect(() => {
      let items = this.directSessionLogic.cartItemsSignal();
    });


    this.getSessionInfo();
    this.getConfigData();

    // Non-prod builds with localDebug on pre-fill the contact form with test data.
    // environment.production is a build-time constant, so this block is dead code
    // (tree-shaken) in the prod build.
    if (!environment.production && environment.ConnectionInfo.localDebug === "true") {
      this.loadDebugData();
    }
  }

  escapeCheck(){
    if(this.directSessionLogic.planSelectedSignal().name === undefined || this.directSessionLogic.planSelectedSignal().name === null) {
      console.log("no plan selected, escaping to top level");
      this.directSessionLogic.escapeToTopLevelSignal();
    }
  }

  initAutocomplete() {
    let address1Field = document.querySelector("#address1") as HTMLInputElement;
    let autocompleteOptions = {
      componentRestrictions: { country: ["us"] },
      fields: ["address_components", "geometry"],
      types: ["address"],
    };
    this.autocomplete = new google.maps.places.Autocomplete(address1Field, autocompleteOptions);
    this.autocomplete.addListener("place_changed", () => {
      const place = this.autocomplete.getPlace();
      if(place.address_components) {
        let addr = place.address_components;
        
        let streetNumber:string = addr.find((part) => part.types.includes('street_number'))?.long_name || '';
        let route:string = addr.find((part) => part.types.includes('route'))?.short_name || '';
        
        let address1:string = streetNumber + ' ' + route;
        let city:string = addr.find((part) => part.types.includes('locality'))?.long_name || '';
        let state:string = addr.find((part) => part.types.includes('administrative_area_level_1'))?.short_name || '';
        let zip:string = addr.find((part) => part.types.includes('postal_code'))?.long_name || '';

        this.customer.address = address1;
        this.customer.city = city;
        this.customer.state = state;
        this.customer.zip = zip;
        this.directSessionLogic.updateCustomerSignal(this.customer);

        this.contactForm.patchValue({
          address:      this.customer.address,
          city:         this.customer.city,
          state:        this.customer.state,
          zipCode:      this.customer.zip
        });
      }
    });
  }

  //Add on exit function to save form data to session
  //ONLY if customer has a name and either (email or phone number)

  getSessionInfo() {    
    if(this.customer != undefined) {
      this.setContactFromSession();
    }else{
      this.startNewContactForSession();
    }
  }

  async getConfigData(){
    this.companyName = environment.CompanyInfo.CompanyName.toString();
    
    this.contactPermissionMessage = environment.LegalData.find( data => 
      data.legalRef == "contact"
      )?.legalText || "error getting contact permission message for $$company$$";

    this.contactPermissionMessage = this.contactPermissionMessage.replace(
      "$_$", this.companyName
    );
  }

  ngOnInit() {

    this.modalAddressMismatch = new bootstrap.Modal("#modalAddressMismatch",{
      keyboard: false,
      backdrop: true,
      focus: true,
    });

    this.stateIDs = this.stateIDs.sort();
    this.validCountries = this.validCountries.sort();



    // Set up interval to check form validity every second
    this.intervalId = setInterval(() => {
      if (this.contactForm.valid && !this.isUpdatedForm() && !this.updateFormLockout) {
        this.updateSessionCustomer();
      }
    }, 1000);


    //sub to each address field individually to help prevent extra API calls
    //otherwise we may accidentally call API repeatedly when filling out phone number, email, etc.
    //any address edit invalidates the previous verification; the actual Google call is debounced
    ['address', 'city', 'state', 'zipCode', 'country'].forEach(field => {
      this.contactForm.get(field)?.valueChanges.subscribe(() => {
        if(this.suppressAddressInvalidation) return;
        this.isAddressVerified = false;
        this.isAddressComplete = this.evalAddressCompleteness();
        if(this.isAddressComplete && this.verifyAddress){
          this.addressValidationPending = true;
          this.addressChanged$.next();
        }
      });
    });
    this.addressChanged$.pipe(debounceTime(600)).subscribe(() => {
      this.validateAddress();
    });

    this.contactForm.valueChanges.subscribe((x) => {
      if(this.contactForm.valid){
        this.updateSessionCustomer();
        this.updateFormLockout = true;
      }
      this.evaluateStepCompletion();
    });

    //address may already be filled from session/debug before subscriptions existed
    this.isAddressComplete = this.evalAddressCompleteness();
    if(this.isAddressComplete && this.verifyAddress && !this.isAddressVerified){
      this.addressValidationPending = true;
      this.addressChanged$.next();
    }
    this.evaluateStepCompletion();
  }

  /** Step is complete only when the form is valid AND the address has been verified */
  private evaluateStepCompletion(){
    const addressOk = !this.verifyAddress || this.isAddressVerified;
    if(this.contactForm.valid && addressOk){
      this.directSessionLogic.completeCurrentStepSignal();
    }else if(this.directSessionLogic.getCurrentStepSignal()?.completed){
      console.log("form invalid or address unverified, uncompleting step");
      this.directSessionLogic.unCompleteCurrentStepSignal();
    }
  }


  // Strip every non-digit character so only the raw phone number is stored
  private sanitizePhoneNumber(value: unknown): string {
    return (value?.toString() ?? '').replace(/[^0-9]/g, '');
  }

  private updateSessionCustomer(){
    console.log('-----form is complete----');
    let cleansedPhoneNumber = this.sanitizePhoneNumber(this.contactForm.get('phone')?.value);

    this.customer.firstName =   this.contactForm.get('firstName')?.value;
    this.customer.lastName =    this.contactForm.get('lastName')?.value;
    this.customer.address =     this.contactForm.get('address')?.value;
    this.customer.city =        this.contactForm.get('city')?.value;
    this.customer.state =       this.contactForm.get('state')?.value;
    this.customer.zip =         this.contactForm.get('zipCode')?.value;
    this.customer.country =     this.contactForm.get('country')?.value;
    this.customer.phoneNumber = cleansedPhoneNumber;
    this.customer.email =       this.contactForm.get('email')?.value;
    
    this.directSessionLogic.updateCustomerSignal(this.customer);
  }

  private isUpdatedForm(): boolean{
    let updated = false;
    let cleansedPhoneNumber = this.sanitizePhoneNumber(this.contactForm.get('phone')?.value);

    updated = (
      this.customer.firstName != this.contactForm.get('firstName')?.value ||
      this.customer.lastName != this.contactForm.get('lastName')?.value ||
      this.customer.address != this.contactForm.get('address')?.value ||
      this.customer.city != this.contactForm.get('city')?.value ||
      this.customer.state != this.contactForm.get('state')?.value ||
      this.customer.zip != this.contactForm.get('zipCode')?.value ||
      this.customer.country != this.contactForm.get('country')?.value ||
      this.customer.phoneNumber != cleansedPhoneNumber ||
      this.customer.email != this.contactForm.get('email')?.value
    );

    return updated;
  }

  
  evalAddressCompleteness(): boolean {
    if(     this.contactForm.get('address')?.value
        &&  this.contactForm.get('city')?.value
        &&  this.contactForm.get('state')?.value
        &&  this.contactForm.get('zipCode')?.value
        &&  this.contactForm.get('country')?.value
        &&  this.contactForm.get('city')?.value.length > 2
        &&  this.contactForm.get('zipCode')?.value.length > 4)
    {
      return true;
    }
    else {
      return false;
    }
  }

  validateAddress() {
    let addressLinesInput:string[] = [
      this.contactForm.get('address')?.value,
      this.contactForm.get('city')?.value + ' '  + this.contactForm.get('state')?.value + ' ' + this.contactForm.get('zipCode')?.value
    ];
    this.googleService.validateAddress(addressLinesInput).subscribe({
      next: (res) => {
        this.addressValidationPending = false;

        if(res.result?.uspsData && res.result.uspsData.deliveryPointCode) {
          this.uspsData = res.result.uspsData;
          this.customer.deliveryPointCode = this.uspsData.deliveryPointCode;
          this.customer.deliveryPointCheckDigit = this.uspsData.deliveryPointCheckDigit;
          this.directSessionLogic.updateCustomerSignal(this.customer);

          //address exists but may or may not need small adjustments
          if(this.uspsData.standardizedAddress) {
            this.enteredAddress = {
              firstAddressLine: this.contactForm.get('address')?.value,
              city: this.contactForm.get('city')?.value,
              state: this.contactForm.get('state')?.value,
              zipCode: this.contactForm.get('zipCode')?.value,
              cityStateZipAddressLine: null,
              zipCodeExtension: null
            };

            const standardized = this.uspsData.standardizedAddress;
            const isExactMatch =
              this.normalizeAddressPart(this.enteredAddress.firstAddressLine) === this.normalizeAddressPart(standardized.firstAddressLine) &&
              this.normalizeAddressPart(this.enteredAddress.city) === this.normalizeAddressPart(standardized.city) &&
              this.normalizeAddressPart(this.enteredAddress.state) === this.normalizeAddressPart(standardized.state) &&
              (this.enteredAddress.zipCode ?? '').substring(0, 5) === (standardized.zipCode ?? '').substring(0, 5);

            if(isExactMatch) {
              this.isAddressVerified = true;
            } else {
              this.isAddressVerified = false;
              this.modalAddressMismatch.show();
            }
          } else {
            //deliverable address with no standardized form returned
            this.isAddressVerified = true;
          }
        }
        //not a plausible/deliverable address
        else {
          this.markAddressUnverified();
        }

        this.evaluateStepCompletion();
      },
      error: (err) => {
        console.error("Error validating address: ", err);
        this.addressValidationPending = false;
        this.markAddressUnverified();
        this.evaluateStepCompletion();
      }
    });
  }

  /** lowercase, strip periods/commas, collapse whitespace — avoids false mismatches like "Dr." vs "DR" */
  private normalizeAddressPart(part: string): string {
    return (part ?? '').toLowerCase().replace(/[.,]/g, '').replace(/\s+/g, ' ').trim();
  }

  private markAddressUnverified() {
    this.isAddressVerified = false;
    this.customer.deliveryPointCode = '';
    this.customer.deliveryPointCheckDigit = '';
  }

  /* User wants to keep editing the address rather than accept the verified one */
  dismissAddressUpdate() {
    this.modalAddressMismatch.hide();
  }

  /* User selected the usps verified address from the modal */
  updateAddressFromUsps() {
    this.customer.address = this.uspsData.standardizedAddress.firstAddressLine;
    this.customer.city = this.uspsData.standardizedAddress.city;
    this.customer.state = this.uspsData.standardizedAddress.state;
    this.customer.zip = this.uspsData.standardizedAddress.zipCode;
    this.directSessionLogic.updateCustomerSignal(this.customer);

    //patch only the address fields (not the whole form) so name/phone/email the user
    //already typed aren't clobbered by a not-yet-synced customer signal.
    //suppress invalidation so this doesn't re-trigger another validation round trip.
    this.suppressAddressInvalidation = true;
    this.contactForm.patchValue({
      address:      this.customer.address,
      city:         this.customer.city,
      state:        this.customer.state,
      zipCode:      this.customer.zip,
    });
    this.suppressAddressInvalidation = false;

    this.modalAddressMismatch.hide();
    this.isAddressVerified = true;
    this.evaluateStepCompletion();
  }


  async setContactFromSession(){
    this.startNewContactForSession();

    this.firstName =  this.customer.firstName;
    this.lastName =   this.customer.lastName;
    this.email =      this.customer.email;
    this.phone =      this.customer.phoneNumber;
    this.address =    this.customer.address;
    this.city =       this.customer.city;
    this.state =      this.customer.state;
    this.zipCode =    this.customer.zip;
    this.country =    this.customer.country;

    this.patchCustomerValues();

    if(!this.contactForm.valid){
      let invalidFields = "Invalid Fields: "
      for (const name in this.contactForm.controls) {
          if (this.contactForm.controls[name].invalid) {
            invalidFields += name + ", ";
          }
      }   
      
      console.log(invalidFields);
    }
  
    if(this.contactForm.valid){
      await this.directSessionLogic.sleep(100);
    }
    this.evaluateStepCompletion();
  }

  startNewContactForSession(){
    this.contactForm = this.builder.group({
      firstName:  ['', [Validators.required, Validators.minLength(2), Validators.maxLength(20) ]],
      lastName:   ['', [Validators.required, Validators.minLength(2), Validators.maxLength(20) ]],
      address:    ['', [Validators.required, Validators.minLength(6) ]],
      city:       ['', [Validators.required, Validators.minLength(2), Validators.maxLength(48) ]],
      state:      ['', [Validators.required, Validators.minLength(2), Validators.maxLength(2) ]],
      zipCode:    ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(this.zipCodeRegex) ]],
      
      // setting default country
      // helps with address verification
      // only 1 option regardless
      // signed off as ok by GP and TS
      country:    ['United States', [Validators.required, Validators.minLength(2), Validators.maxLength(48) ]],
      phone:      ['', [Validators.required, Validators.minLength(10), Validators.maxLength(12), Validators.pattern(this.phoneRegex) ]],
      email:      ['', [Validators.required, Validators.email, Validators.pattern(this.emailRegex) ]],
    }); 
  }

  ngAfterViewInit(): void {
    if (this.autocompleteAddress) {
      this.initAutocomplete();
    }
  }

  ngOnDestroy(): void {
    // Clear the interval when the component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  loadDebugData() {
    // Don't overwrite a customer who already has data (e.g. returning to the step)
    if (this.customer.firstName !== "") return;

    this.customer.firstName = "John";
    this.customer.lastName = "SANDBOX";
    this.customer.email = "blankblakn@TESTTESTTEST.com";
    this.customer.phoneNumber = "5555555555";
    this.customer.address = "1234 Main St";
    this.customer.city = "Anytown";
    this.customer.state = "CA";
    this.customer.zip = "12345";
    this.customer.country = "United States";

    console.log("proxy account", this.customer);

    this.directSessionLogic.updateCustomerSignal(this.customer);

    this.patchCustomerValues();

    //debug stub address isn't real — skip verification so the step isn't blocked
    this.isAddressVerified = true;
  }

  patchCustomerValues(){
    this.contactForm.patchValue({
      firstName:    this.customer.firstName,
      lastName:     this.customer.lastName,
      email:        this.customer.email,
      phone:        this.customer.phoneNumber,
      address:      this.customer.address,
      city:         this.customer.city,
      state:        this.customer.state,
      zipCode:      this.customer.zip,
      country:      this.customer.country || 'United States'
    });
  }
}


  

